import React, { useId } from 'react';
import { Box, InputLabel, TextField as MuiTextField } from '@mui/material';
import * as styles from './TextField.scss';

const TextField = (props) => {
  const {
    data,
    disabled,
    error,
    errorText,
    helperText,
    id,
    label,
    maxLength,
    maxRows,
    minRows,
    multiline,
    rows,
    onChange,
    placeholder,
    required,
    size = 'small',
    slotProps,
    sx,
    type,
    uncontrolled,
    value,
  } = props;

  const generatedId = useId();

  return (
    <Box className={styles.textFieldContainer} sx={sx}>
      {label && <InputLabel htmlFor={id ?? generatedId} shrink={false} error={!!error} required={required}>{label}</InputLabel>}
      <MuiTextField
        id={id ?? generatedId}
        value={!uncontrolled ? value ?? data?.value ?? '' : undefined}
        disabled={disabled}
        error={!!(error ?? data?.error)}
        fullWidth
        helperText={errorText ?? data?.errorText ?? helperText}
        multiline={multiline}
        maxRows={maxRows}
        minRows={minRows}
        rows={rows}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        size={size}
        slotProps={{ ...slotProps, htmlInput: { ...slotProps?.htmlInput, maxLength } }}
        type={type}
      />
    </Box>
  );
};

export default TextField;
